import React from 'react'
import { Link } from 'gatsby'
import Logo from '@/assets/logo_white.svg'

export default function Footer(): JSX.Element {
  return (
    <footer className="footer">
      <div className="footer-inner-container">
        <Link to="/">
          <Logo className="footer-logo" />
        </Link>
        <div className="footer-top">
          <ul className="footer-top__nav-wrapper">
            <div className="footer-top__nav">
              <li className="footer-top__nav-item">
                <Link to="/" className="footer-top__nav-item-link">
                  トップページ
                </Link>
              </li>
              <li className="footer-top__nav-item">
                <Link
                  to="/shops/index_map/"
                  className="footer-top__nav-item-link"
                >
                  店舗検索
                </Link>
              </li>
              <li className="footer-top__nav-item">
                <a
                  href="https://trial-holdings.inc/company/"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="footer-top__nav-item-link"
                >
                  会社情報
                </a>
              </li>
              <li className="footer-top__nav-item">
                <a
                  href="https://trial-holdings.inc/careers/"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="footer-top__nav-item-link"
                >
                  採用情報
                </a>
              </li>
            </div>
            <div className="footer-top__nav">
              <li className="footer-top__nav-item">
                <Link to="/prepaid/" className="footer-top__nav-item-link">
                  トライアルプリペイドカード
                </Link>
              </li>
              <li className="footer-top__nav-item">
                <Link to="/faq/" className="footer-top__nav-item-link">
                  よくあるご質問
                </Link>
              </li>
              <li className="footer-top__nav-item">
                <Link to="/contacts/" className="footer-top__nav-item-link">
                  お問い合わせ
                </Link>
              </li>
              <li className="footer-top__nav-item">
                <a
                  href="https://trial-holdings.inc/news/release/"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="footer-top__nav-item-link"
                >
                  お知らせ
                </a>
              </li>
            </div>
            <div className="footer-top__nav">
              <li className="footer-top__nav-item">
                <a
                  href="https://tralink.trial-net.co.jp/TrialLink/login.aspx"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="footer-top__nav-item-link"
                >
                  トラリンク
                </a>
              </li>
              <li className="footer-top__nav-item">
                <a
                  href="http://one88.jp/trial/"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="footer-top__nav-item-link"
                >
                  BtoB請求書
                </a>
              </li>
              <li className="footer-top__nav-item">
                <Link to="/tenant/" className="footer-top__nav-item-link">
                  テナント募集
                </Link>
              </li>
              <li className="footer-top__nav-item">
                <Link to="/cookie/" className="footer-top__nav-item-link">
                  Cookie管理
                </Link>
              </li>
            </div>
            <div className="footer-top__nav">
              <li className="footer-top__nav-item">
                <a
                  href="https://www.trial-net.co.jp/mag/"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="footer-top__nav-item-link"
                >
                  トライアルマガジン
                </a>
              </li>
            </div>
          </ul>
        </div>
        <div className="footer-bottom">
          <ul className="footer-bottom__nav-wrapper">
            <div className="footer-bottom__nav">
              <li className="footer-bottom__nav-item">
                <a
                  href="https://trial-holdings.inc/legal/privacy-policy/"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="footer-bottom__nav-item-link"
                >
                  個人情報保護方針
                </a>
              </li>
              <li className="footer-bottom__nav-item">
                <Link
                  to="/aicamerapolicy/"
                  className="footer-bottom__nav-item-link"
                >
                  AIカメラ撮影ポリシー
                </Link>
              </li>
            </div>
            <div className="footer-bottom__nav">
              <li className="footer-bottom__nav-item">
                <a
                  href="https://trial-holdings.inc/legal/terms/"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="footer-bottom__nav-item-link"
                >
                  サイトのご利用条件
                </a>
              </li>
              <li className="footer-bottom__nav-item">
                <a
                  href="https://trial-holdings.inc/legal/sns-policy/"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="footer-bottom__nav-item-link"
                >
                  SNSポリシー
                </a>
              </li>
            </div>
            <div className="footer-bottom__nav">
              <li className="footer-bottom__nav-item">
                <a
                  href="https://trial-holdings.inc/legal/security-policy/"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="footer-bottom__nav-item-link"
                >
                  情報セキュリティーポリシー
                </a>
              </li>
            </div>
          </ul>
          <div className="footer-bottom__copyright">
            <small>
              Copyright&copy;TRIAL Company Inc. All rights reserved.
            </small>
          </div>
        </div>
      </div>
    </footer>
  )
}
